export default __webpack_public_path__ + "static/media/Masquerade.b90bf8aa.mp3";